export const environment = {
  production: true,
  configuration_name: 'prod',
  release_pick_transfers: true,
  mode: 'rep',
};
